import $ from "jquery"
import View from "../../View"
import LoadingContainer from '../../util/LoadingContainer'
import PanelContainer from '../../components/PanelContainer'
import {HIDE_ANIMATION_CLASSES, SHOW_ANIMATION_CLASSES} from '../constants'
import messageResource from '../../messageResource'


export default class TaskPanelContainer extends View {
    constructor({
        additionalClass,
        panelContent,
        panelType = '',
        reloadComments = () => {},
        openPanel = () => {},
        loadPanelData = () => {},
        onPanelHideCb = () =>  {},
        needToHideOnOutsideClick = true,
        showCopyLink = true,
        needShowMoire = false,
        copyLink = () => {},
        hideHandler = () => this.panelContainer.setState({isShown: false}),
    }) {
        super()

        this.actions = {
            reloadComments,
            openPanel,
            loadPanelData,
        }

        this.callbacks = {
            onPanelHideCb,
            copyLink,
            hideHandler,
        }

        this.params = {
            panelContent,
            panelType,
            additionalClass,
            needToHideOnOutsideClick,
            needShowMoire,
            showCopyLink,
        }

        this.state = {
            isShown: false,
            loading: false,
            needToLoadData: false,
        }

        this.onStatePropertyChanged('isShown', (isShown) => {
            this.panelContainer.setState({isShown: isShown})
        })

        this.onStatePropertyChanged('loading', loading => {
            this.loadingContainer.setState({loading})
        })

        this.onStatePropertyBecameTrue('needToLoadData', () => this.actions.loadPanelData())
    }

    afterRender() {
        this.loadingContainer = new LoadingContainer({
            contentComponent: this.params.panelContent,
        })

        this.panelContainer = new PanelContainer({
            component: this.loadingContainer,
            additionalClass: this.params.additionalClass,
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: this.params.needToHideOnOutsideClick,
                panelType: this.params.panelType,
            },
            onHideCallback: () => this.callbacks.onPanelHideCb(),
            showMoire: this.params.needShowMoire,
            showCopyLink: this.params.showCopyLink,
            copyLinkTooltipText: messageResource.getMessage('task.edit_panel.copy_link_tooltip_text'),
            showHideButton: true,
            hideHandler: () => {
                this.callbacks.hideHandler()
                this.params.panelContent.onHide()
            },
            onCopyLinkClick: () => this.callbacks.copyLink(),
            onClickCloseButton: () => this.callbacks.hideHandler(),
        }).init($('body'))
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/TaskPanelContainer.js